import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { InlineSVGModule } from 'ng-inline-svg-2';
import { CounterFormatPipe } from '../../../core/pipes/counter-format-pipe';
import { DateAgoPipe } from '../../../core/pipes/date.ago.pipe';
import { EllipsisPipe } from '../../../core/pipes/ellipsis.pipe';
import { PostLandingLayoutComponent } from '../../../layouts/post-landing-layout/post-landing-layout.component';
import { ADRectangleComponent } from '../../../shared/components/ads/rectangle/rectangle.component';
import { ModalComponent } from '../../../shared/components/modals/modal/modal.component';
import { InputRadioFancyComponent } from '../../../shared/modules/inputs/components/radio-fancy/radio-fancy.component';
import { RecaptchaComponent } from '../../../shared/modules/inputs/components/recaptcha/recaptcha.component';
import { InputTextareaComponent } from '../../../shared/modules/inputs/components/textarea/textarea.component';
import { AuthorComponent } from './components/author/author.component';
import { PostActivityComponent } from './components/post-activity/post-activity.component';
import { CommentDetailsComponent } from './components/post-comments/comment-details/comment-details.component';
import { NewCommentFormComponent } from './components/post-comments/new-comment-form/new-comment-form.component';
import { PostCommentsComponent } from './components/post-comments/post-comments.component';
import { PostDetailsComponent } from './components/post-details/post-details.component';
import { PostUrlComponent } from './components/post-url/post-url.component';
import { ReportPostComponent } from './components/report-post/report-post.component';
import { StatisticsComponent } from './components/statistics/statistics.component';
import { LandingPageComponent } from './pages/landing-page/landing-page.component';
import { PostLandingRoutingModule } from './post-landing-routing.module';
import { SharedModule } from '../../../shared/shared-module';
import { LandingPostService } from './services/landing-post.service';

@NgModule({
  declarations: [
    LandingPageComponent,
    AuthorComponent,
    StatisticsComponent,
    PostDetailsComponent,
    PostActivityComponent,
    PostCommentsComponent,
    CommentDetailsComponent,
    NewCommentFormComponent,
    PostUrlComponent,
    ReportPostComponent,
  ],
  imports: [
    PostLandingLayoutComponent,
    PostLandingRoutingModule,
    ADRectangleComponent,

    ReactiveFormsModule,
    EllipsisPipe,
    CounterFormatPipe,
    DateAgoPipe,
    ModalComponent,
    InputRadioFancyComponent,
    InputTextareaComponent,
    RecaptchaComponent,
    SharedModule,
  ],
})
export class PostLandingModule {}
